// Los IDS son de uso interno y el generador no los entiende —
// ADR-2026-09-25-los-ids-no-salen-en-el-prompt-ni-al-usuario.
//
// El agente ve `image_id=…` y `adjunto_id=m1-2` en los marcadores del historial (es como
// REUSA una imagen), y a veces los copia adentro del `prompt` de la generación: "the exact
// same room from Imagen ya generada: image_id=5fda189a-…". El motor de imagen no sabe qué
// es un id: es ruido, y en el peor caso lo dibuja como texto. La regla del prompt se lo
// dice al modelo; esto es la red de abajo: se saca el id y queda la frase.
//
// Puro.

const CLAVES_DE_ID = '(?:image_id|adjunto_id|product_id|model_id|pose_id|fondo_id|foto_id|lote_id|chat_id)';
/** `image_id=…`, `image_id: "…"`, `image_id …`, con o sin comillas. */
const RE_CLAVE_VALOR = new RegExp(`\\(?\\b${CLAVES_DE_ID}\\s*[=:]?\\s*["'\`]?[\\w-]+["'\`]?\\)?`, 'gi');
/** Un UUID suelto (los ids de las imágenes generadas). */
const RE_UUID = /["'`(]?\b[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\b["'`)]?/gi;

/** El prompt sin ids: lo que quedaría si el agente nunca los hubiera escrito. */
export function limpiarIdsDelPrompt(prompt: string): string {
  if (!prompt) return prompt;
  let out = prompt.replace(RE_CLAVE_VALOR, '').replace(RE_UUID, '');
  if (out === prompt) return prompt;
  return (
    out
      // "(  )" y "( : )" que quedaron vacíos.
      .replace(/\(\s*[:=,-]?\s*\)/g, '')
      // "Imagen ya generada: ." → "Imagen ya generada."; "…, ." → "…."
      .replace(/\s*[:=,]\s*([.,;)\n]|$)/g, '$1')
      // Dos espacios seguidos, y un espacio antes de la puntuación.
      .replace(/[ \t]{2,}/g, ' ')
      .replace(/ +([.,;)])/g, '$1')
      .replace(/\( +/g, '(')
      .trim()
  );
}
